import React from "react";

//material ui
import { Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import LoadingButton from "@mui/lab/LoadingButton";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const useStyles = (theme, isMobile) => ({
  payButton: {
    background: "linear-gradient(103deg, #f32c4d, #d00e2e)",
    color: theme.palette.white.main,
    width: "277px",
    height: "65px",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "space-evenly",
    "& .MuiCircularProgress-root": {
      width: "24px !important",
      height: "24px !important",
      color: "#e4e4e4",
    },
    "& .MuiLoadingButton-loadingIndicator": {
      left: "45%",
    },
  },
  disabledButton: {
    background: "linear-gradient(103deg, #9c9c9c, #acacacb8)",
    color: theme.palette.white.main,
    width: "277px",
    height: "65px",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "space-evenly",
  },
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#d00e2e",
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  disabledIcon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#9c9c9c",
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  typography: {
    title: {
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
      minWidth: "177.77px",
    },
    zeroOpacityTitle: {
      opacity: 0,
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
      minWidth: "177.77px",
    },
    disabled: {
      color: "#e4e4e4",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
      minWidth: "177.77px",
    },
  },
});

const PayButton = ({ text, handleSubmit, form, disabled, loading }) => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  return (
    <LoadingButton
      loading={loading}
      disabled={disabled}
      sx={
        disabled
          ? loading
            ? classes.payButton
            : classes.disabledButton
          : classes.payButton
      }
      endIcon={
        <ArrowForwardIosIcon
          sx={disabled ? classes.disabledIcon : classes.icon}
        />
      }
      onClick={handleSubmit}
    >
      <Typography
        sx={
          disabled
            ? loading
              ? classes.typography.zeroOpacityTitle
              : classes.typography.disabled
            : loading
            ? classes.typography.zeroOpacityTitle
            : classes.typography.title
        }
      >
        {text}
      </Typography>
    </LoadingButton>
  );
};

export default PayButton;
